import moment from "moment";
import { Money, PayStub } from "types/landlord/reports";

const getCentsValue = (value?: Money | null) => {
  return value?.cents || 0;
};

export const mapTablePaystubData = (paystubs: PayStub[]) => {
  return paystubs.reduce((acc, paystub) => {
    const paymentReferenceDate = moment(paystub.pay_period_details.pay_date)
      .startOf("month")
      .format("MMM, YYYY");

    const referenceRow = acc.find((row) => row.date === paymentReferenceDate);

    if (!referenceRow)
      acc.push({
        id: paystub.employer?.name || "Unknown Employer",
        date: paymentReferenceDate,
        base: getCentsValue(paystub.earnings?.base),
        bonus: getCentsValue(paystub.earnings?.bonus),
        total_gross: getCentsValue(paystub.gross_earnings),
        tax: getCentsValue(paystub.deductions),
        total_net: getCentsValue(paystub.net_pay),
        subRows: [
          {
            id: 1,
            date: formatDate(paystub.pay_period_details.pay_date),
            base: getCentsValue(paystub.earnings?.base),
            bonus: getCentsValue(paystub.earnings?.bonus),
            total_gross: getCentsValue(paystub.gross_earnings),
            tax: getCentsValue(paystub.deductions),
            total_net: getCentsValue(paystub.net_pay)
          }
        ]
      });
    else {
      referenceRow.base += getCentsValue(paystub.earnings?.base);
      referenceRow.bonus += getCentsValue(paystub.earnings?.bonus);
      referenceRow.total_gross += getCentsValue(paystub.gross_earnings);
      referenceRow.tax += getCentsValue(paystub.deductions);
      referenceRow.total_net += getCentsValue(paystub.net_pay);
      referenceRow.subRows.push({
        id: referenceRow.subRows.length + 1,
        date: formatDate(paystub.pay_period_details.pay_date),
        base: getCentsValue(paystub.earnings?.base),
        bonus: getCentsValue(paystub.earnings?.bonus),
        total_gross: getCentsValue(paystub.gross_earnings),
        tax: getCentsValue(paystub.deductions),
        total_net: getCentsValue(paystub.net_pay)
      });
    }

    return acc;
  }, [] as any[]);
};

export const formatDate = (date?: string | null, withAt?: boolean) => {
  if (!date) return "--";

  if (withAt) return moment(date).format("ll [at] h:mma");

  return moment(date).format("ll");
};

export const centsToAmount = (cents: number) => {
  if (!cents) return 0;

  return cents / 100;
};

export const formatEnumValue = (value: string) => {
  return value.replaceAll("_", " ").toLowerCase();
};
